import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BulkUpdateTasks } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList } from '@fluentui/react-components';
import { ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

const BulkOwnerUpdateMenu = ({ selectedRows, onBulkUpdateComplete, children }) => {
    const dispatch = useDispatch();
    const { projectUsersAll } = useSelector(state => state.team);
    const [open, setOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const handleBulkUserAssignment = async user => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            // Update all selected tasks with the new owner using bulk update
            await dispatch(
                BulkUpdateTasks({
                    taskIds: selectedRows,
                    updates: { assigned_to: user.value.user_id },
                    suppressToast: true,
                }),
            );

            // Call the completion callback
            if (onBulkUpdateComplete) {
                onBulkUpdateComplete(user, selectedRows.length);
            }

            setOpen(false);
        } catch (error) {
            console.error('Error updating bulk task assignments:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>
                {children || (
                    <div className={styles.bulkUpdateMenu} style={{ opacity: isUpdating ? 0.6 : 1 }}>
                        Owner <ChevronDown12Regular className="ms-1" />
                    </div>
                )}
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    {/* Project Users List */}
                    {projectUsersAll && projectUsersAll.length > 0 ? (
                        projectUsersAll
                            .filter(user => user.value && user.value.user_id)
                            .map(user => (
                                <div
                                    key={user.value.user_id}
                                    onClick={() => handleBulkUserAssignment(user)}
                                    className={styles.tagMenuItem}
                                    style={{ opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                                    <span>{user.value.full_name}</span>
                                </div>
                            ))
                    ) : (
                        <div>
                            <p>No users available</p>
                        </div>
                    )}
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default BulkOwnerUpdateMenu;
